import React from 'react';
// import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";

import { HashRouter as Router, Routes, Route } from "react-router-dom";

// Local
import './css/App.css';
import DateAndTimePickers from './Components/DateRange.js';
import Landing from './Components/Landing.js';
import Contribute from './Components/Contribute.js';
import AdminRequests from './Components/AdminRequests.js';

import { Container } from '@mui/material';
import { RequestsTable } from './Components/RequestsTable';
import Request from './Components/Request';
import Thread from './Components/Thread';
import Search from './Components/Search';
import TemporaryDrawer from './Components/Navigation';
import { AuthProvider } from './contexts/AuthContext';


function RequestsList() {
  return (
		<Container>
			<RequestsTable />
		</Container>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Router>
          <TemporaryDrawer/>
          <Routes>
            <Route path="/requests/" element={<RequestsList />} />
            <Route path="/request/:requestId" element={<Request />} />
            <Route path="/thread/:threadId" element={<Thread />} />
            <Route path="/search/:searchString" element={<Search />} />
            <Route path="/search/" element={<Search />} />
            <Route path="/range/" element={<DateAndTimePickers />} />
            <Route path="/contribute/" element={<Contribute />} />
            <Route path="/admin/requests" element={<AdminRequests />} />
            <Route path="/" element={<Landing />} />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}
